/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetSkillEfficacySettingsSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type GetSkillEfficacySettingsRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetSkillEfficacySettingsSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetSkillEfficacySettingsSecurity$outboundSchema: z.ZodMiniType<
  GetSkillEfficacySettingsSecurity$Outbound,
  GetSkillEfficacySettingsSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getSkillEfficacySettingsSecurityToJSON(
  getSkillEfficacySettingsSecurity: GetSkillEfficacySettingsSecurity,
): string {
  return JSON.stringify(
    GetSkillEfficacySettingsSecurity$outboundSchema.parse(
      getSkillEfficacySettingsSecurity,
    ),
  );
}

/** @internal */
export type GetSkillEfficacySettingsRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetSkillEfficacySettingsRequest$outboundSchema: z.ZodMiniType<
  GetSkillEfficacySettingsRequest$Outbound,
  GetSkillEfficacySettingsRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
    });
  }),
);

export function getSkillEfficacySettingsRequestToJSON(
  getSkillEfficacySettingsRequest: GetSkillEfficacySettingsRequest,
): string {
  return JSON.stringify(
    GetSkillEfficacySettingsRequest$outboundSchema.parse(
      getSkillEfficacySettingsRequest,
    ),
  );
}
